import React from 'react'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
// import classes from './styles.module.scss'
import { createForm } from 'rc-form'
import { Flex, WhiteSpace, WingBlank } from 'antd-mobile'
import { Header, Button } from 'components'
import { Helmet } from 'react-helmet'
import queryString from 'query-string'
import { isPayBy, PayByInfo, intl } from 'utils'

class Error extends React.Component {
  constructor(props) {
    super(props)
    const params = queryString.parse(props.location.search)
    this.state = {
      code: params.code,
      msg: params.msg,
    }
    // props.init()
  }

  handleCloseWebview = () => {
    if (PayByInfo().hostAppName === 'we-credit') {
      return window.history.back()
    }
    window.location.href = '/close?paymentStatus=Fail'
  }

  render() {
    const { code, msg } = this.state
    return (
      <React.Fragment>
        <Helmet>
          <title>{intl.formatMessage(messages.title)}</title>
        </Helmet>
        <Header>
          <FormattedMessage {...messages.title} />
        </Header>
        <Flex.Item>
          <WhiteSpace size='xl' />
          <WhiteSpace size='xl' />
          <WhiteSpace size='xl' />
          <WhiteSpace size='xl' />
          <WhiteSpace size='xl' />
          <WhiteSpace size='xl' />
          <div className='text-center'>
            <span className='iconfont font-xl red iconState-Failed' />
            <WhiteSpace />
            <WhiteSpace />
            <p className='font-md'>
              <b>{msg}</b>
            </p>
            <WhiteSpace size='sm' />
            {code && (
              <p className='font-sm'>
                <FormattedMessage {...messages.code} />: {code}
              </p>
            )}
          </div>
          <WingBlank>
            <WhiteSpace size='lg' />
            <WhiteSpace size='lg' />
            {isPayBy() && (
              <Button
                type='light'
                name='finish'
                onClick={this.handleCloseWebview}
              />
            )}
          </WingBlank>
        </Flex.Item>
      </React.Fragment>
    )
  }
}

export default createForm()(Error)
